





































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
/* api */
import AccountEditApi from '@/app/model/api/accountEditApi'
import AccountDetailApi from '@/app/model/api/accountDetailApi'
import AccountDeleteApi from '@/app/model/api/accountDeleteApi'
import GroupListApi from '@/app/model/api/groupListApi'
/* module */
import Validator from '@/app/module/validator'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    ErrorModal,
    ErrorInfo,
    DeleteModal
  }
})

export default class AccountEdit extends Vue {
  /* データ */
  private accountData: any = this.$store.state.accountState.accountData
  private userId: string = ''
  private id: string = ''
  private account: string = ''
  private name: string = ''
  private tel: string = ''
  private email: string = ''
  private password: string = ''
  private groupname: string = ''
  private errorMessages: any = ''
  private remarks: string = ''
  private timeStamp: number = 0
  private groupList: any = []
  private alertText: string = ''
  private alertTitle: string = ''
  private isDelete: boolean = false
  private constantValue: any = []
  /* 表示非表示 */
  private showLoading: boolean = true
  private showPasswordInput: boolean = false
  private showFiledModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.userId = this.$route.params.user_id
    this.getGroupList()
    this.getAccountList()
  }

  private getGroupList () {
    (async () => {
      /* 初期表示はグループ名の昇順 */
      let data: any = {
        order_name: 'group_name',
        sort: 'asc',
        text: ''
      }

      const result = await GroupListApi.getGroupList(data)
      if (result.isOk()) {
        this.groupList = result.getPayload().groups
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    })()
  }

  /* ユーザー一覧取得 */
  public getAccountList () {
    (async () => {
      const result = await AccountDetailApi.getAccountDetail(this.userId)

      if (result.isOk()) {
        this.accountData = result.getPayload()

        // ヘッダー
        let accountHeader: any = this.$refs.accountHeader
        if (accountHeader !== undefined) {
          accountHeader.getUserName(this.accountData)
        }

        this.id = this.userId
        this.account = this.accountData.user_type
        this.name = this.accountData.name
        this.tel = this.accountData.tell
        this.email = this.accountData.mailaddress
        this.groupname = this.accountData.group_id
        this.remarks = this.accountData.remarks
        this.timeStamp = this.accountData.time_stamp

        // userTypeの判定
        if (parseInt(this.account) === userType.USER_TYPE_ADMIN) {
          this.isDelete = true
        }

        this.showLoading = false
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }

      this.showLoading = false
    })()
  }

  /* パスワード自動生成 */
  private displayPassword () {
    this.password = this.createPassword()
  }

  private createPassword () {
    let str: string = 'abcdefghijklmnopqrstuvwxyz0123456789!"#$%&()_-'
    let len: number = 12

    let result: string = ''
    for (var i = 0; i < len; i++) {
      result += str.charAt(Math.floor(Math.random() * str.length))
    }
    return result
  }

  private async doAccountEdit () {
    let fieldIdList: number[] = []
    let passwordFlag = 0

    if (!this.isAccountEdit()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }

    if (this.showPasswordInput) {
      // パスワードが必須なとき
      passwordFlag = 1
    }

    /* ユーザー登録処理が成功したらユーザー一覧に遷移、失敗したらアラートを表示 */
    const bodyData = {
      'name': this.name,
      'user_type': parseInt(this.account),
      'tell': this.tel,
      'mailaddress': this.email,
      'group_id': parseInt(this.groupname),
      'password': this.password,
      'password_flag': passwordFlag,
      'remarks': this.remarks,
      'time_stamp': this.timeStamp
    }

    const result = await AccountEditApi.doAccountEdit(this.$route.params.user_id, bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'ユーザー編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/user').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private isAccountEdit () {
    const accountFlag = Validator.validateInputAccount('accountErrorMessage', parseInt(this.account))
    const nameFlag = Validator.validateInputName('nameErrorMessage', this.name)
    const telFlag = Validator.validateInputTel('telErrorMessage', this.tel)
    const emailFlag = Validator.validateInputEmail('emailErrorMessage', this.email)
    let passwordFlag = Validator.validateInputPassword('passwordErrorMessage', this.password)

    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    if (!this.showPasswordInput) {
      passwordFlag = true
    }

    return accountFlag && nameFlag && telFlag && emailFlag && passwordFlag
  }

  private changePassword () {
    this.showPasswordInput = true
  }

  /* ユーザー削除 */
  private doAccountDelete () {
    (async () => {
      const result = await AccountDeleteApi.doAccountDelete(this.$route.params.user_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'ユーザーを削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/user').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  private doCancel () {
    this.$router.push('/master/user').catch(e => {})
  }

  private displayRemarks (data: string) {
    if (data !== '' && data !== undefined) {
      if (data.length > 20) {
        return data.substr(0, 20) + '…'
      } else {
        return data
      }
    }
  }
}
